// @tidal-export

import { validateTidalLicense } from '@workwave-tidal/core/base'

export { ConversationEditor } from './components/Editor/ConversationEditor.js'
// export { ConversationEditorAction } from './components/Editor/components/ConversationEditorAction.js'

export { ConversationEmpty } from './components/Empty/ConversationEmpty.js'

export { ConversationFab } from './components/Fab/ConversationFab.js'
export type { ConversationFabProps } from './components/Fab/types.js'

export { ConversationPanel, type ConversationPanelProps } from './components/ConversationPanel/ConversationPanel.js'

export { ConversationHeader } from './components/Header/ConversationHeader.js'
export { ConversationHeaderActions } from './components/Header/components/ConversationHeaderActions.js'
export { ConversationHeaderContent } from './components/Header/components/ConversationHeaderContent.js'
export { ConversationHeaderDefaultActions } from './components/Header/ConversationHeaderDefaultActions.js'

export { InteractionLoading } from './components/Interactions/components/Interaction/components/InteractionLoading.js'
export { InteractionMark } from './components/Interactions/components/Interaction/components/InteractionMark.js'
export { MessageTypography } from './components/Interactions/components/Interaction/components/MessageTypography.js'
export { ConversationInteractions } from './components/Interactions/ConversationInteractions.js'
export { ConversationInteraction } from './components/Interactions/components/Interaction/ConversationInteraction.js'
export {
  Rating,
  type RatingProps,
} from './components/Interactions/actions/Rating.js'
export {
  type InteractionCustomSlotProps,
  InteractionCustomSlot,
} from './components/Interactions/components/Interaction/components/InteractionCustomSlot.js'

export {
  ConversationSuggestions,
  type ConversationSuggestionsProps,
} from './components/Suggestions/ConversationSuggestions.js'
export {
  ConversationSuggestion,
  type ConversationSuggestionProps,
} from './components/Suggestions/ConversationSuggestion.js'

export { Conversation } from './Conversation.js'

export type {
  ConversationEditorProps,
  ConversationHeaderProps,
  ConversationInteractionsProps,
  ConversationProps,
  ConversationInteractionProps,
  InteractionSuggestion,
  OnRating,
  RatingReaction,
  ConversationApi,
} from './types.js'

export { Feedback as ConversationFeedback } from './components/Feedback/Feedback.js'
export type {
  FeedbackProps as ConversationFeedbackProps,
  FeedbackSuggestion,
  FeedbackFormState,
} from './components/Feedback/types.js'

export type { FloatingConversationProps } from './components/FloatingConversation/types.js'
export { FloatingConversation } from './components/FloatingConversation/FloatingConversation.js'
export type { FloatingConversationApi } from './components/FloatingConversation/types.js'

export {
  useFloatingConversationApi,
  useChatOpen,
  useFullscreen,
} from './components/FloatingConversation/components/FloatingConversationApiProvider.js'
export { useConversationApi, useOverlayContent, useWaitingForResponse } from './components/ConversationApiProvider.js'

// #license-validation
validateTidalLicense()
